import FormManualTransfer from './FormManualTransfer.vue';

export default FormManualTransfer;
